import React, {Dispatch, SetStateAction, useCallback, useContext} from 'react';

import {Search, SearchInterface} from '@veneer/core';

import {GlobalTranslationsContext} from '../../i18n';

const TextFilter = <K extends string, F extends Partial<Record<K, string>>>({
    label,
    filters,
    setFilters,
    field,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
}): JSX.Element => {
    const {veneer: v} = useContext(GlobalTranslationsContext);
    const handleChange = useCallback<Required<SearchInterface>['onChange']>(
        value => setFilters(filters => ({...filters, [field]: value || undefined})),
        [field, setFilters]
    );
    return (
        <Search
            label={label}
            id={`text-filter-${field}`}
            delay={500}
            value={filters[field] || ''}
            onChange={handleChange}
            i18n={v.search}
        />
    );
};

export default TextFilter;
